module.exports = __webpack_public_path__ + "static/img/adv_icon5.48c90c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/adv_icon5.png
// module id = bZmq
// module chunks = 1